export const setupTokenExpiryWarning = () => {
  // Cookie sessions are opaque to JavaScript. The backend validates them on
  // startup and for every request, so no client-side JWT timer is used.
  return () => {};
};
